import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  http: HttpClient;
  constructor(http: HttpClient) {
    this.http = http;
  }

  getCompanies() {
    return this.http.get('/Account/GetCompanies').toPromise();
  }

  login(loginData: any) {
    return this.http.post("/Account/Login",
    {
      actionModel: loginData
    }).toPromise();
  }

  windowsLogin(loginData: any) {
    return this.http.post("/Account/WindowsLogin", loginData).toPromise();
  }

  requestPasswordReset(employeeNum: number, prco: number, inputPin: string) {
    return this.http.post("/Account/RequestPasswordReset",
    {
      employee: employeeNum,
      pRCo: prco,
      inputPin: inputPin
    }).toPromise();
  }

  createAccount(accountData: any) {
    return this.http.post("/Account/Create",
      {
        actionModel: accountData
      }).toPromise();
  }

  checkReturnUrl(returnUrl: string) {
    return this.http.get("/Account/CheckReturnUrl?returnUrl=" + returnUrl).toPromise();
  }

  getCompanyNumFromUrl(coString: string) {
    return this.http.get("/Account/GetCompanyNumFromUrl?coString=" + coString).toPromise();
  }

  namedLogin(username: string, password: string) {
    return this.http.post("/Account/NamedLogin", { username: username, password: password }).toPromise();
  }

  getVistaTidEnabled() {
    return this.http.get("/Account/GetVistaTidEnabled").toPromise();
  }
}
